export default [
  // Authenticated routes.
  ...middleware("auth", [
    {
      path: "/dashboard",
      name: "dashboard",
      component: require("~/pages/dashboard")
    },
    {
      path: "/markets",
      name: "markets",
      component: require("~/pages/markets")
    },
    {
      path: "/performance",
      name: "performance",
      component: require("~/pages/performance")
    },
    {
      path: "/subscriptions",
      name: "subscriptions",
      component: require("~/pages/subscriptions")
    },
    {
      path: "/settings",
      name: "settings",
      component: require("~/pages/settings/index")
    },
    {
      path: "/openorders",
      name: "open-orders",
      component: require("~/pages/openorders")
    },
    {
      path: "/referral",
      name: "referral",
      component: require("~/pages/referral")
    },
    {
      path: "/partners",
      name: "partners",
      component: require("~/pages/partners")
    },
    {
      path: "/marketallocations",
      name: "marketallocations",
      component: require("~/pages/marketallocations")
    },
    {
      path: "/whitelabel",
      name: "whitelabel",
      component: require("~/pages/whitelabel")
    },
    ...middleware("admin", [
      { path: "/admin", name: "admin", component: require("~/pages/admin") },
    ])
  ]),

  // Guest routes.
  ...middleware("guest", [
    { path: "/", name: "welcome", component: require("~/pages/welcome") },
    { path: "/login", name: "login", component: require("~/pages/auth/login") },
    {
      path: "/register",
      name: "register",
      component: require("~/pages/auth/register")
    },
    {
      path: "/register/verify/:token?",
      name: "register-verify",
      component: require("~/pages/auth/register-verify")
    },
    {
      path: "/password/reset",
      name: "password.request",
      component: require("~/pages/auth/password/email")
    },
    {
      path: "/password/reset/:token",
      name: "password.reset",
      component: require("~/pages/auth/password/reset")
    },
    {
      path: "/puzzle",
      name: "puzzle",
      component: require("~/pages/puzzle/index")
    }
  ]),
  {
    path: "/terms",
    name: "terms",
    alias: "/legal/terms",
    component: () => (window.location.href = "/pdf/20210625 - General terms and Conditions GSMG v. 1.0.pdf")
  },
  {
    path: "/risk",
    name: "risk",
    alias: "/legal/risk",
    component: () => (window.location.href = "/pdf/20210625 - Risk Disclosure Statement GSMG v. 1.0.pdf")
  },
  {
    path: "/privacy",
    name: "privacy",
    alias: "/legal/privacy",
    component: () => (window.location.href = "/pdf/20210625 - Privacy Policy GSMG v.1.0.pdf")
  },
  {
    path: "/yummy",
    name: "yummy",
    alias: "/legal/yummy",
    component: () => (window.location.href = "/pdf/20210531 - Cookies Policy for GSMG v. 1.0.pdf")
  },

  { path: "*", component: require("~/pages/errors/404.vue") }
];

/**
 * @param  {String|Function} middleware
 * @param  {Array} routes
 * @return {Array}
 */
function middleware(middleware, routes) {
  routes.forEach(route =>
    (route.middleware || (route.middleware = [])).unshift(middleware)
  );

  return routes;
}



// WEBPACK FOOTER //
// ./resources/js/router/routes.js